export default "__VITE_ASSET__snUV1rYN__"